import React, { useState } from 'react';
import { ConfirmButton, InputIdentifier } from '../../VehicleIdentifier.styles';
import plateService from '../../../../services/plate.service';
import PlateInfo from '../../../../models/plate-info.entity';
import storageService from '../../../../services/storage.service';
import authService from '../../../../auth/auth.service';
import AuthUser from '../../../../auth/models/auth-user.entity';
import { useHistory } from 'react-router-dom';
import { ErrorMsg } from '../../../Home/components/Banner/components/PlateInput/PlateInput.styles';
import { CircularProgress } from '@mui/material';
import { LocalStoreKeysEnum } from '../../../../models/enums/localstore-keys.enum';

const identifierStyle = {
  disabledBtn: {
    background: '#BFBEBE'
  }
}

export function PlateOrChassiIdentifier() {
  const history = useHistory();

  const [plate, setPlate] = useState('');
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  // const [isBtnAble, setIsBtnAble] = useState(false);

  const isPlateOrChassi = (value: string): boolean => {
    if (plate.length !== 7 && plate.length !== 17) return false;

    const cleanedValue = value.trim().toUpperCase();
    const plateRegex = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/;
    const chassiRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
    return plateRegex.test(cleanedValue) || chassiRegex.test(cleanedValue);
  }

  const isBtnAble = isPlateOrChassi(plate);

  const handleChange = (e: any) => {
    const { value } = e.target;
    setPlate(value.toUpperCase().replace(/[^a-zA-Z0-9\s]/g, ""));
  };


  const goToPlateConfirm = () => {
    history.push('plate-confirmation');
  };

  const getAuth = () => {
    authService.getToken()
      .then((result) => {
        const user: AuthUser = new AuthUser();
        user.accessToken = result.token;

        authService.saveAuth(user.formatAuthPayload());
      })
      .catch();
  }

  const searchByPlate = () => {
    setLoading(true);
    plateService.searchByPlate(plate)
      .then((result) => {
        const { data } = result.data;
        data.plate = plate;
        const plateInfo = new PlateInfo(data);

        storageService.setObject('plateInfo', plateInfo);

        const { inspection_value } = data;
        localStorage.setItem(LocalStoreKeysEnum.LABEL_INSPECTION_PRICE, inspection_value);
        getAuth();
        goToPlateConfirm();
      })
      .catch((error) => {
        setShowError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <InputIdentifier
        type="text"
        name="plate"
        maxLength="17"
        data-testid="input-plate"
        value={plate}
        onChange={handleChange}
        placeholder="Digite a placa ou chassi do veículo"
      />
      {showError && (<ErrorMsg>Não encontramos informação para a placa informada</ErrorMsg>)}
      <ConfirmButton
        type="button"
        onClick={searchByPlate}
        disabled={!isBtnAble}
        style={!isBtnAble ? identifierStyle.disabledBtn : {}}
      >
        {!loading && ('Continuar compra')}
        {loading && (
          <CircularProgress sx={{ color: '#fff' }} size={23} />
        )}
      </ConfirmButton>
    </>
  );
}
